import frMessages from '../locales/fr_FR';

const frLang = {
  messages: {
    ...frMessages,
  },
  locale: 'fr-FR',
};

export default frLang;